import React, { useState, useEffect, useMemo } from 'react';

const AttributeSelectors = ({ options, counts, data, onChange }) => {
  const [selections, setSelections] = useState({});

  const computeFields = (data, counts) => {
    const result = [];
    const hasData = !!data?.Primary || !!data?.PCA || (data?.Guests?.length || 0) > 0 || (data?.Children?.length || 0) > 0;
  
    if(data.PCA != undefined && counts?.passenger == 1){
      data.PCA = {Name: "PCA", Attributes: ""}
    }
    if(data.Primary != undefined && counts?.passenger == 0){
      
      data.Primary = {Name: "Primary", Attributes: ""};
      data.PCA = {Name: "PCA", Attributes: ""}
      
      data.Guests = [];
    }

    if(data.Children != undefined && counts?.children == 0){
      data.Children = [];
    }

    if (!hasData) {
      if (counts?.passenger >= 1) 
      {
        result.push("Primary");
        result.Primary = { Name: "Primary", Attributes: "" }
      }
      if (counts?.passenger > 1) 
      {
        result.push("PCA");
        result.PCA = { Name: "PCA", Attributes: "" }
      }

      for (let i = 0; i < Math.max(0, counts.passenger - 2); i++) 
      {
        const guest = `Guest ${i + 1}`;
        result.push(guest);
        result[guest] = { Name: guest, Attributes: "" };
      }
      for (let i = 0; i < (counts?.children ?? 0); i++) 
      {
        const child = `Child ${i + 1}`;
        result.push(child);
        result[child] = { Name: child, Attributes: "" };
      }
    } 
    else {
      if (data?.Primary && counts?.passenger > 0) 
      {
        result.push("Primary");
        result.Primary = { Name: "Primary", Attributes: "" }
      }
      if (data?.PCA && counts?.passenger > 1)
      {
        result.push("PCA");
        result.PCA = { Name: "PCA", Attributes: "" }
      } 
      for (let i = 0; i < Math.min(data?.Guests?.length ?? 0, Math.max(0, (counts?.passenger ?? 0) - 2)); i++) {
        const guest = `Guest ${i + 1}`;
        result.push(guest);
        result[guest] = { Name: guest, Attributes: "" };
      }
      for (let i = 0; i < Math.min(data?.Children?.length ?? 0, counts?.children ?? 0); i++) {
        const child = `Child ${i + 1}`;
        result.push(child);
        result[child] = { Name: child, Attributes: "" };
      }
    }
  
    return result;
  };
  
  const fields = useMemo(() => computeFields(data, counts), [data, counts]);
  
  useEffect(() => {
    if (!data) return;
    const newSelections = {};

    const getDefault = () => {
      return (
        options.find(opt =>
          ['amb', 'ambu', 'ambulatory'].some(keyword =>
            opt.value?.toLowerCase().startsWith(keyword)
          )
        )?.key || ''
      );
    };
  
    if (data.Primary) newSelections["Primary"] = data.Primary.Attributes || getDefault();;
    newSelections["PCA"] = data.PCA?.Attributes || getDefault();
  
    const guests = data.Guests ?? [];
    const children = data.Children ?? [];
  
    for (let i = 0; i < Math.max(0, (counts?.passenger ?? guests.length + 2) - 2); i++) {
      newSelections[`Guest ${i + 1}`] = guests[i]?.Attributes || getDefault();;
    }
    for (let i = 0; i < (counts?.children ?? children.length); i++) {
      newSelections[`Child ${i + 1}`] = children[i]?.Attributes || getDefault();;
    }
    
    const hasChanges = JSON.stringify(selections) !== JSON.stringify(newSelections);
    if (hasChanges) {
      setSelections(newSelections);
      onChange?.(newSelections);
    }
  }, [data, counts, options]);
  
  
  const handleChange = (field, value) => {
    const updated = {
      ...selections,
      [field]: value
    };
    setSelections(updated);
    onChange?.(updated);
  };

  useEffect(() => {

    return () => {}

  }, [])


  return (
    <div className="p-1 space-y-4">
      {fields.map((field, idx) => {
        const hash = [...field].reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const hue = hash % 360;
        const bgColor = `hsl(${hue}, 70%, 85%)`;
    
        return (
          <div key={idx} className="flex items-center space-x-4" style={{ marginBottom: "5px" }}>
            <label
              className="text-right"
              style={{
                width: "35%",
                backgroundColor: bgColor,
                padding: "4px 8px",
                borderRadius: "4px"
              }}
            >
              {field}:
            </label>
            <select
              style={{ width: "65%" }}
              value={selections[field] ?? (
                options.find(opt =>
                  ['amb', 'ambu', 'ambulatory'].some(keyword =>
                    opt.value?.toLowerCase().startsWith(keyword)
                  )
                )?.key || ''
              )}
              className="border border-gray-300 rounded px-3 py-1"
              onChange={(e) => handleChange(field, e.target.value)}
            >
              <option value="" disabled>Select option</option>
              {options.map((option, index) => (
                <option key={index} value={option.key}>
                  {option.value}
              </option>
              ))}

            </select>
          </div>
        );
      })}
  </div>
  );
};

export default AttributeSelectors;
